import {formatDate} from "@ui-seeker/utils";


export default function firstSeenColumn() {
	return {
		name: 'firstSeen',
		label: 'First Seen on Retailer',
		options: {
			setCellProps: () => ({ sx: { textAlign: 'center' } }),
			customBodyRowRender: value => !value ? 'N/A' :  formatDate(value, { isString: true })
		}
	}
}